import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import DoorConfiguration from './DoorConfiguration'
import { addDoorAction } from 'actions/entityActions'
import { currentDoorControllerSelector, doorControllerUsagesSelector, showDoorControllerTotalUsagesSelector,
  doorControllerTotalUsagesSelector, doorControllerModelTotalLimitsSelector } from 'selectors/components'
import getNewDeviceLocation from 'helpers/accessControl/getNewDeviceLocation'
import toTitle from 'helpers/accessControl/toTitle'
import tippy from 'tippy.js'

function mapStateToProps(state) {
  return {
    currentDoorController: currentDoorControllerSelector(state),
    usages: doorControllerUsagesSelector(state),
    showTotalUsages: showDoorControllerTotalUsagesSelector(state),
    totalUsages: doorControllerTotalUsagesSelector(state),
    totalLimits: doorControllerModelTotalLimitsSelector(state),
    map: state.map.ref
  }
}

class DoorControllerDesigner extends React.Component {
  componentDidMount = _ => tippy(`.${this.props.classes.helpIcon}`, { duration: 0, theme: 'topbar', placement: 'top', onShow: instance => this.tooltip = instance })

  componentWillUnmount = _ => this.tooltip && this.tooltip.hide()

  fadeClasses = _ => {
    const { classes } = this.props

    return {
      appear: classes.fadeAppear,
      appearActive: classes.fadeAppearActive,
      appearDone: classes.fadeAppearDone,
      enter: classes.fadeEnter,
      enterActive: classes.fadeEnterActive,
      enterDone: classes.fadeEnterDone,
      exit: classes.fadeExit,
      exitActive: classes.fadeExitActive,
      exitDone: classes.fadeExitDone
    }
  }

  addDoorDisabled = _ => {
    const { currentDoorController: { doorIds, model: { limits } }, showTotalUsages, totalUsages, totalLimits } = this.props

    return doorIds.length >= limits.doors || (showTotalUsages && totalUsages.doors >= totalLimits.doors)
  }

  addDoor = _ => {
    const { currentDoorController: { id, location, headingCounter }, map, addDoorAction } = this.props

    if (this.addDoorDisabled()) return

    addDoorAction(id, getNewDeviceLocation(map, location, headingCounter))
  }

  render() {
    const { currentDoorController, usages, showTotalUsages, totalUsages, totalLimits, classes } = this.props
    const { doorIds, model, model: { limits } } = currentDoorController
    const addDoorDisabled = this.addDoorDisabled()

    const transitionProps = {
      timeout: 200,
      unmountOnExit: true,
      classNames: this.fadeClasses()
    }

    return (
      <div className={classes.container}>
        { Object.keys(usages).map((key, index) =>
            <div className={classes.header} key={key} style={{ gridRow: index + 1 }}>
              <span>{toTitle(key)}</span>
              <div className={classes.lineWrapper}>
                <div className={classes.bubble}>
                  <div
                    className={classes.line + (usages[key] >= limits[key] ? ' full' : '')}
                    style={{ width: `${Math.min(100 * (usages[key] / limits[key]), 100)}%` }}
                  />
                </div>
                <span style={{ flex: 1 }}>{usages[key]} Used</span>
                <span>{limits[key]} Max</span>
              </div>
              { showTotalUsages &&
                <div className={classes.lineWrapper}>
                  <div className={classes.bubble}>
                    <div
                      className={classes.totalLine + (totalUsages[key] >= totalLimits[key] ? ' full' : '')}
                      style={{ width: `${Math.min(100 * (totalUsages[key] / totalLimits[key]), 100)}%` }}
                    />
                  </div>
                  <span className={classes.totalLabel}>
                    {totalUsages[key]} Total on Main
                    <a className={classes.helpIcon} title='Total usage across main controller and all expansion controllers'>
                      <FontAwesomeIcon icon='info-circle' />
                    </a>
                  </span>
                </div>
              }
            </div>
          )
        }
        <div className={classes.headerBackground} />
        <TransitionGroup style={{ display: 'contents' }}>
          { doorIds.map((id, index) =>
              <CSSTransition key={id} {...transitionProps}>
                <DoorConfiguration
                  id={id}
                  model={model}
                  usages={usages}
                  totals={{ show: showTotalUsages, usages: totalUsages, limits: totalLimits }}
                  gridColumn={index + 2}
                />
              </CSSTransition>
            )
          }
        </TransitionGroup>
        <div onClick={this.addDoor} className={classes.newDoorButton + (addDoorDisabled ? ' disabled' : '') + (doorIds.length >= 4 ? ' shrunk' : '')}>
          <div>
            <span className='fa-layers fa-fw' style={{ fontSize: '2.5rem', marginRight: '.5rem' }}>
              <FontAwesomeIcon icon={['far', 'door-open']} />
              <FontAwesomeIcon icon='circle' inverse transform='shrink-6 down-7 right-8' />
              <FontAwesomeIcon icon='plus' transform='shrink-9 down-7 right-8' />
            </span>
            Add Door
          </div>
          { addDoorDisabled &&
            <div className={classes.warningText}>
              <FontAwesomeIcon icon='exclamation-triangle' className={classes.warningIcon} />
              { doorIds.length >= 4 ? 'Cannot add more doors' : 'This controller cannot add more doors' }
            </div>
          }
        </div>
      </div>
    )
  }
}

export const DoorControllerDesignerConfig = { title: 'Configure', width: '95vw' }
export default connect(mapStateToProps, { addDoorAction })(injectSheet(style)(DoorControllerDesigner))



// WEBPACK FOOTER //
// ./src/components/DoorControllerDesigner/index.js